import axios from 'axios'

export default {
  getServiceTicket(term) {
        return axios.get('/api/serviceTickets/lookup?Ticket=' + encodeURIComponent(term));
  },
  
}



// WEBPACK FOOTER //
// ./ClientApp/app/shared/components/serviceticketselector/api.js